// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8Mxqu","colMin":"styles_colMin__1yivS"};